import { authPut } from "@api";
import { DEPLOYMENT_URL } from "@constants";

import { Integration, IntegrationBody } from "@pages/settings/types";

export const updateIntegration = (
  deploymentId: string,
  integration: Integration,
  token?: string
) => {
  let integrationBody: IntegrationBody = integration;
  if (token) {
    integrationBody.token = token;
  }
  return authPut<IntegrationBody, Integration>(
    `${DEPLOYMENT_URL}/${deploymentId}/integrations/${integration.id}`,
    integrationBody
  );
};
